<template>
  <div id="centerRight1">
    <div class="bg-color-black">
      <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="align-left" class="text-icon"></icon>
        </span>
        <div class="d-flex">
          <span class="fs-xl text mx-2">基层首诊人数</span>
        </div>
      </div>
      <div class="d-flex jc-center body-box">
        <dv-scroll-board class="dv-scr-board" :config="config" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      config: {
        header: ['区域', '人数', '占比'],
        data: [
          ['兴安街道', '7685','92.2%'],
          ['新安街道', '5676','91.96%'],
          ['凌河街道', '5047','91.87%'],
          ['景芝镇', '321','86.05%'],
		  ['官庄镇', '2754','96%'],
		  ['大盛镇', '352','96.62%'],
		  ['石埠子镇', '654','93.32%'],
		  ['石堆镇', '2135','91.96%'],
		  ['拓山镇', '2754','91.87%'],
		  ['辉渠镇', '352','86.05%'],
		  ['吾山镇', '654','92.2%'],
		  ['金冢子镇', '2135','93.32%']
        ],
        rowNum: 7, //表格行数
        headerHeight: 35,
        headerBGC: '#0f1325', //表头
        oddRowBGC: '#0f1325', //奇数行
        evenRowBGC: '#171c33', //偶数行
        // index: true,
        columnWidth: [250],
        align: ['left']
      }
    }
  },
  components: {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
#centerRight1 {
  padding: 16px;
  padding-top: 20px;
  height: 400px;
  width: 100%;
  border-radius: 5px;
  .bg-color-black {
    height: 320px;
    border-radius: 10px;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 10px;
    overflow: hidden;
    .dv-scr-board {
      width: 100%;
      height: 320px;
    }
  }
}
</style>
